var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCtaArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9343 4.42611L10.9344 4.42598L10.93 4.421L7.85417 0.960488C7.61809 0.680384 7.16225 0.658232 6.89246 0.899736C6.62296 1.14098 6.59335 1.59706 6.8456 1.86285L8.91987 4.19513H1.5769C1.20306 4.19513 0.9 4.49821 0.9 4.87205C0.9 5.24591 1.20306 5.54897 1.5769 5.54897H8.91987L6.84559 7.88126C6.59217 8.14831 6.62993 8.60362 6.89809 8.84366L6.96299 8.77116L6.89809 8.84367C7.16779 9.08507 7.61803 9.0638 7.85417 8.78362L10.93 5.3231L10.9304 5.32346L10.9365 5.31498C11.046 5.16251 11.1023 5.00917 11.0999 4.85483C11.0975 4.70035 11.0364 4.55762 10.9343 4.42611Z",
    fill: "#00C48C",
    stroke: "#00C48C",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaArrowRight);
export default __webpack_public_path__ + "static/media/cta_arrow_right.61987326.svg";
export { ForwardRef as ReactComponent };